/**
 * A copy dos modais que CONECTAM as ferramentas dentro do chat (19/09/2026).
 *
 * ★ **Por que num arquivo próprio.** `constants/Text.js` deste módulo já passa
 * de 800 linhas e vem sendo quebrado por assunto (`Text.curadoria.js`,
 * `Text.propostas-lote.js`); esta é a próxima fatia. O `Text.js` re-exporta, de
 * modo que quem consome continua importando de um lugar só.
 *
 * ★ **É copy, não contrato.** Nada aqui atravessa o fio: rótulo de botão, texto
 * de apoio e título são deste lado, igual ao `copy.js` do cartão de onboarding.
 * O que o backend define (os escopos de OAuth, o texto dos termos, os tipos de
 * conexão) vem da API e NÃO é redigitado aqui.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 */

export const CONECTAR_EMAIL_AGENDA_TEXT = {
  sobretitulo: 'Integrações',
  titulo: 'E-mail e calendário',
  descricao:
    'Conecte sua conta Google ou Microsoft para sincronizar e-mails do CRM e eventos de agenda. Apenas um provedor por vez: para trocar, revogue o atual antes de conectar o outro.',
  rotuloPermissoes: 'Permissões',
  // Fica abaixo do cartão de permissões e explica por que o botão nasce
  // desabilitado — sem ela, "Autorizar" cinza parece defeito.
  ajudaPermissoes: 'Ative pelo menos uma permissão para autorizar.',
  cancelar: 'Cancelar',
  // O rótulo acompanha o provedor escolhido: "Autorizar Google".
  autorizarPrefixo: 'Autorizar ',
  revogar: 'Revogar',
  conectadoComo: 'Conectado como ',
  // ⚠️ Vai à tela quando o OUTRO provedor está ligado: o backend guarda um
  // token por profissional, então ligar o segundo derrubaria o primeiro sem
  // avisar. O texto diz a saída, não só o impedimento.
  outroProvedorPrefixo: 'Você já está conectado ao ',
  outroProvedorSufixo:
    '. Revogue essa integração antes de conectar a outra conta.',
  erroDeStatus: 'Não foi possível verificar as integrações agora.',
  confirmarRevogacao: {
    titulo: 'Revogar integração',
    texto:
      'Os acessos concedidos serão removidos e a sincronização de e-mails e agenda para de funcionar. Você pode autorizar de novo quando quiser.',
    confirmar: 'Revogar',
    cancelar: 'Cancelar',
  },
}

/**
 * ⚠️ **Os escopos por provedor NÃO são redigitados aqui.** Eles vêm de
 * `@modules/crm/constants/GoogleIntegrationPermissions` e
 * `.../MicrosoftIntegrationPermissions`, que já são a fonte de `name`,
 * `description`, `usage` e `dataKey` — e que o modal do CRM também consome.
 * Uma segunda grafia dos mesmos três escopos divergiria do backend sem ninguém
 * notar: o consentimento sairia dizendo uma coisa e pedindo outra.
 *
 * O que É daqui: a grafia do selo (`CRM · E-mails`), porque o `usage` do CRM
 * usa hífen (`CRM - Emails`) e o desenho pede o ponto médio com acento.
 */
export const SELO_DE_ESCOPO = {
  'CRM - Emails': 'CRM · E-mails',
  'CRM - Calendário': 'CRM · Calendário',
}

export const CONECTAR_WHATSAPP_TEXT = {
  sobretitulo: 'WhatsApp',
  titulo: 'Nova conexão',
  descricao:
    'Dê um nome à conexão e escolha o tipo. Conexões individuais ficam vinculadas ao seu usuário.',
  rotuloNome: 'Nome da conexão',
  placeholderNome: 'Ex.: Atendimento Herik',
  rotuloTipo: 'Tipo',
  tipoIndividual: 'individual',
  tipoCompartilhado: 'compartilhado',
  explicacaoIndividual: 'Conexão individual vinculada ao seu usuário.',
  explicacaoCompartilhada:
    'Conexões compartilhadas podem ser usadas por vários profissionais. Você atribui quem usa depois de criar.',
  aceiteAntes: 'Li e concordo com os ',
  aceiteDestaque: 'Termos de Uso',
  aceiteDepois: ' do módulo de Mensagens WhatsApp',
  lerTermos: 'Ler',
  ocultarTermos: 'Ocultar',
  versaoPrefixo: 'Versão ',
  cancelar: 'Cancelar',
  criar: 'Criar conexão',
  erroAoAceitar: 'Não foi possível registrar o aceite dos termos.',
  erroAoCriar: 'Não foi possível criar a conexão.',
}

export const CONECTAR_WHATSAPP_QRCODE_TEXT = {
  sobretitulo: 'WhatsApp',
  titulo: 'Escaneie para conectar',
  instrucaoAntes: 'Abra o WhatsApp no celular, vá em ',
  instrucaoCaminho: 'Configurações › Aparelhos conectados › Conectar um aparelho',
  instrucaoDepois: ' e aponte a câmera para o código.',
  aguardando: 'Aguardando leitura',
  expiraAntes: 'O código expira em ',
  expiraDepois: '. Se expirar, gere um novo sem sair daqui.',
  expirado: 'O código expirou. Gere um novo para continuar.',
  rotuloConexao: 'Conexão',
  rotuloTipo: 'Tipo',
  gerarNovo: 'Gerar novo código',
  cancelar: 'Cancelar',
  altDoCodigo: 'QR Code para conectar o WhatsApp',
  conectado: 'WhatsApp conectado!',
  // O desenho mostra 1:00. É relógio LOCAL — nem o `POST /connect` nem o
  // `GET /qrcode` devolvem validade (verificado em `apiAtendimentoConexao`),
  // e a Evolution rotaciona o código em torno desse intervalo.
  segundosDeValidade: 60,
}
